import { Box, Chevron, Text, Touchable } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  name: string
  minutes: number
  open: Record<string, boolean>
  toggleOpen: (name: string) => void
}

const Header = ({ name, minutes, open, toggleOpen }: Props) => {
  return (
    <Touchable onClick={() => toggleOpen(name)}>
      <Box gap="s6" alignItems="center" flexDirection="row" width="full">
        <Chevron direction={open[name] ? 'up' : 'down'} type="terciary" />
        <Text size="300" weight="medium" color="grey1000">
          {name}
        </Text>
      </Box>
      <MinutesToText
        color="grey1000"
        value={minutes || 0}
        size="300"
        weight="medium"
        whiteSpace="nowrap"
      />
    </Touchable>
  )
}

export default Header
